import { motion } from 'framer-motion';
import OnboardingProgressThread from './OnboardingProgressThread';
import { ONBOARDING_TOTAL_STEPS, PLATE_BASE, PLATES, SCRIMS } from './onboardingContent';
import { OnbGhostButton } from './OnboardingType';

// Background plates are environments only — every word, control and Presence is runtime.
const Plate = ({ step, objectClass }) => {
  const slug = PLATES[step];
  return (
    <>
      <picture>
        <source
          media="(min-width: 1024px)"
          srcSet={`${PLATE_BASE}/${slug}-desktop-1440.webp 1440w, ${PLATE_BASE}/${slug}-desktop-1920.webp 1920w`}
          sizes="100vw"
        />
        <img
          src={`${PLATE_BASE}/${slug}-mobile-828.webp`}
          srcSet={`${PLATE_BASE}/${slug}-mobile-640.webp 640w, ${PLATE_BASE}/${slug}-mobile-828.webp 828w`}
          sizes="100vw"
          alt=""
          aria-hidden="true"
          className={`absolute inset-0 h-full w-full object-cover ${objectClass}`}
        />
      </picture>
      <div className="absolute inset-0 lg:hidden" style={{ background: SCRIMS[step].mobile }} />
      <div className="absolute inset-0 hidden lg:block" style={{ background: SCRIMS[step].desktop }} />
    </>
  );
};

export const OnboardingScene = ({
  step,
  copy,
  align = 'end',
  desktopAlign = 'center',
  objectClass = 'object-center',
  onBack,
  footer,
  hideFooterOnDesktop = false,
  children,
}) => (
  <div
    className="relative min-h-[100dvh] w-full overflow-hidden bg-[#05070f] lg:h-[100dvh] lg:min-h-0"
    data-testid={`onboarding-screen-${step}`}
  >
    <Plate step={step} objectClass={objectClass} />

    <div
      className="relative z-10 mx-auto flex min-h-[100dvh] w-full flex-col px-6 lg:h-full lg:min-h-0 lg:max-w-[1760px] lg:px-20 xl:px-28"
      style={{
        paddingTop: 'calc(env(safe-area-inset-top, 0px) + 22px)',
        paddingBottom: 'calc(env(safe-area-inset-bottom, 0px) + 26px)',
      }}
    >
      <header className="flex shrink-0 items-center gap-5 lg:gap-9">
        <span
          className="whitespace-nowrap text-[1.05rem] lg:text-2xl text-[#D4A843]"
          style={{ fontFamily: '"Cormorant Garamond", Georgia, serif', fontWeight: 400 }}
          data-testid="onboarding-wordmark"
        >
          {copy.wordmark}
        </span>
        <div className="flex max-w-[26rem] flex-1 items-center lg:max-w-[34rem]">
          <OnboardingProgressThread step={step} total={ONBOARDING_TOTAL_STEPS} />
        </div>
      </header>

      <main className="flex min-h-0 flex-1 overflow-y-auto">
        <motion.div
          key={step}
          initial={{ opacity: 0, y: 16 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.7, ease: [0.16, 1, 0.3, 1] }}
          className={`flex w-full flex-col py-10 lg:py-10 xl:py-14 ${align === 'center' ? 'my-auto' : 'mt-auto'} ${desktopAlign === 'end' ? 'lg:mt-auto lg:mb-0' : 'lg:my-auto'}`}
        >
          {children}
        </motion.div>
      </main>

      <footer className={`flex shrink-0 flex-wrap items-center gap-3 gap-y-3 lg:gap-5 ${hideFooterOnDesktop ? 'onb-hide-desktop' : ''}`}>
        {onBack && (
          <OnbGhostButton onClick={onBack} testId={`onboarding-back-btn-${step}`}>
            {copy.back}
          </OnbGhostButton>
        )}
        {footer}
      </footer>
    </div>
  </div>
);

export default OnboardingScene;
